exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".close[data-v-88dcd158]{position:absolute;right:32px;top:32px;width:32px;height:32px;opacity:.3}.close[data-v-88dcd158]:hover{opacity:1}.close[data-v-88dcd158]:after,.close[data-v-88dcd158]:before{position:absolute;left:15px;content:\" \";height:33px;width:2px;background-color:#333}.close[data-v-88dcd158]:before{transform:rotate(45deg)}.close[data-v-88dcd158]:after{transform:rotate(-45deg)}", ""]);

// exports
